import { CalendarFilled } from '@ant-design/icons'
import { DatePicker, Input, message } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import { applyVacation } from '../../../api/aops.vacation.api'
import { userState } from '../../../store/user'
import AopsCommonModalLayout from '../modal/AopsCommonModalLayout'
import ModalStatusButtonGroup from '../modal/ModalStatusButtonGroup'
const returnLeaveType = () => {
  return [
    { label: '연차', value: 'DAY' },
    { label: '반차', value: 'HALF' },
    { label: '반반차', value: 'QUARTER' },
  ]
}
const returnTimeSlot = () => {
  return [
    { label: '종일', value: 'ALL' },
    { label: '오전', value: 'AM' },
    { label: '오후', value: 'PM' },
  ]
}
const AopsVacationModal = ({
  open = false,
  onClose,
  title = '연차 신청',
  onRefresh,
}) => {
  const [user] = useRecoilState(userState)
  const [formData, setFormData] = useState({
    targetDate: '',
    leaveType: '연차',
    timeSlot: '종일',
    description: '',
  })
  const openErrorModal = (error) => {
    // 여러 줄 메시지를 지원하기 위해 html 옵션 사용
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'info',
      html: '이미 신청한 연차가 있습니다.<br/>취소 후 다시 신청해주세요 ',
      confirmButtonText: '확인',
    })
  }
  const resetForm = () => {
    setFormData({
      targetDate: '',
      leaveType: '연차',
      timeSlot: '종일',
      description: '',
    })
    onClose()
  }
  useEffect(() => {
    if (!open) resetForm()
  }, [open])

  const validateForm = () => {
    if (!formData.targetDate) {
      message.error('날짜를 선택해주세요.')
      return false
    }
    if (!formData.leaveType) {
      message.error('연차 종류를 선택해주세요.')
      return false
    }
    if (!formData.timeSlot) {
      message.error('시간 대를 선택해주세요.')
      return false
    }
    if (!formData.description) {
      message.error('휴가 사유를 입력해주세요.')
      return false
    }
    return true
  }

  const handleApplyVacation = async () => {
    if (!validateForm()) return

    const leaveTypeValue = returnLeaveType().find(
      (item) => item.label === formData.leaveType,
    )?.value

    const timeSlotValue = returnTimeSlot().find(
      (item) => item.label === formData.timeSlot.trim(),
    )?.value

    const payload = {
      userId: user?.id,
      targetStartDate: dayjs(formData.targetDate).format('YYYY-MM-DD'),
      targetEndDate: dayjs(formData.targetDate).format('YYYY-MM-DD'),
      leaveType: leaveTypeValue,
      timeSlot: timeSlotValue,
      description: formData.description,
    }

    try {
      const response = await applyVacation(payload)
      console.log(response)
      message.success('연차 신청이 완료되었습니다.')
      resetForm()
      onRefresh()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
      return
    }
  }
  return (
    <AopsCommonModalLayout open={open} onClose={onClose} title={title}>
      <div className="form-container">
        <div className="form-wrapper">
          <div className="form-section">
            <label className="form-label">사용 일자</label>
            <div style={{ width: '100%' }}>
              {/* 날짜 선택 컴포넌트 */}
              <DatePicker
                style={{ width: '50%' }}
                placeholder="날짜를 선택해주세요"
                value={formData.targetDate}
                disabledDate={(current) =>
                  current && current < dayjs().startOf('day')
                }
                onChange={(date) => {
                  setFormData({ ...formData, targetDate: date })
                }}
                suffixIcon={
                  <CalendarFilled
                    style={{ fontSize: '18px', color: '#585F65' }}
                  />
                  // <img
                  //   src={`${process.env.PUBLIC_URL}/assets/icon/aops/calendar-filled-icon.svg`}
                  //   alt="calendar"
                  //   style={{ fontSize: '18px', color: '#585F65' }}
                  // />
                }
                className="vacation-date-picker"
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">연차 종류</label>
            <div style={{ width: '100%' }}>
              <ModalStatusButtonGroup
                options={['연차', '반차', '반반차']}
                value={formData.leaveType}
                style={{ width: '100%' }}
                onChange={(label) => {
                  // 연차 선택 시 시간대를 '종일'로, 반차/반반차 선택 시 '오전'으로 자동 설정
                  const newTimeSlot = label === '연차' ? '종일' : '오전'
                  setFormData({
                    ...formData,
                    leaveType: label,
                    timeSlot: newTimeSlot,
                  })
                }}
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">시간 대 </label>
            <div style={{ width: '100%' }}>
              <ModalStatusButtonGroup
                options={
                  formData.leaveType === '연차' ? ['종일'] : ['오전', '오후']
                }
                value={formData.timeSlot}
                onChange={(label) =>
                  setFormData({ ...formData, timeSlot: label })
                }
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">휴가 사유 </label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="당분간은 '개인사유'로 적어주시면 감사하겠습니다"
                value={formData.description}
                onChange={(e) => {
                  if (e.target.value.length > 51) return
                  setFormData({ ...formData, description: e.target.value })
                }}
                className="form-textarea"
                rows={4}
              />
            </div>
          </div>
          <div
            style={{
              padding: `20px 24px`,
              backgroundColor: '#F6F7FA',
              borderRadius: '8px',
              fontSize: '14px',
              color: '#8C979D',
              fontWeight: '400',
              lineHeight: '1.8',
              letterSpacing: '0.02em',
            }}
          >
            <p>
              1. 연차는 근로기준법에 따라 발생한 개인별 잔여 연차에 한하여
              사용함을 원칙으로 합니다.
            </p>
            <p>
              2. 연차 사용은 사전 신청 및 승인 절차를 거쳐야 하며, 회사 사정에
              따라 일정 조정이 요청될 수 있습니다.
            </p>
            <p>
              3. 연차 사용과 관련된 세부 기준은 사내 연차 운영 정책에 따릅니다.
            </p>
          </div>
        </div>

        <div className="popup-footer">
          <button className="btn-cancel" onClick={onClose}>
            취소
          </button>
          <button className="btn-submit" onClick={handleApplyVacation}>
            연차 신청
          </button>
        </div>
      </div>
    </AopsCommonModalLayout>
  )
}

export default AopsVacationModal
